import React, {FC, ReactNode, useRef} from 'react';
import NoSSR from "@/utils/no-ssr";
import { Switch as LegacySwitch } from "@progress/kendo-react-inputs";
import { colors } from '@/theme';
import Helper from '@/utils/helper';
import { Group, MantineColor, Switch, SwitchProps } from "@mantine/core";

const useLegacy = false;

function SCSwitch(
    { name, checked, label, onLabel, offLabel, title = "", disabled = false, onChange, flexRight = false, extraClasses, cypress, onToggle, mt = 'sm', color }:
        {
            name?: string; checked?: boolean; label?: string | ReactNode; onLabel?: string; offLabel?: string; title?: string,
            disabled?: boolean, onChange?: ({name, value}: any) => {}, flexRight?: boolean, extraClasses?: any,
            cypress?: any, onToggle?: (checked: boolean) => void,
            color?:MantineColor
        } & Omit<SwitchProps, 'onToggle' | 'onChange'>
){

    const switchProps: SwitchProps = {
        name,
        checked: Helper.isNullOrUndefined(checked) ? false : checked,
        label: label || onLabel || offLabel,
        title,
        disabled,
        mt,
        color,
        // onLabel,
        // offLabel
    }


    const ref = useRef<HTMLInputElement>(null);

    const handleChange = (event: any) => {

        /*console.log('value vs checked', event.currentTarget.checked,
        event.currentTarget.value)*/
        onToggle && onToggle(event.currentTarget.checked)
        onChange && onChange({name, value: event.currentTarget.checked});
    };

    const handleChangeLegacy = (event: any) => {
        onChange && onChange({name: name, value: event.value});
    };

    const handleLabelClick = () => {
    };


    //             <style jsx>{`
    //                 .label {
    //                     margin-left: 0.5rem;
    //                     font-size: 16px;
    //                     color: ${colors.labelGrey};
    //             `}</style>
    // };

    return (
        // todo test title prop behaviour

        !useLegacy ?
            <NoSSR>
                <Group>
                    <Switch
                        {...switchProps}
                        ref={ref}
                        size={'sm'}
                        styles={{
                            trackLabel: {paddingInline: 0}
                        }}
                        color={ color || 'scBlue'}
                        onChange={handleChange}
                    />
                </Group>
            </NoSSR>
            :
            <div title={title} className={`switch-container ${extraClasses} ${flexRight ? 'reverse' : ''}`}>
                <NoSSR>
                    <LegacySwitch
                        ref={ref}
                        name={name}
                        onLabel={onLabel}
                        offLabel={offLabel}
                        onChange={handleChangeLegacy}
                        disabled={disabled}
                        className={cypress}
                    />
                </NoSSR>
                <style jsx>{`
                  .switch-container {
                    margin-top: 0.5rem;
                  }

                  .reverse {
                    display: flex;
                    flex-direction: row-reverse;
                  }
                `}</style>
            </div>
    );
}

export default SCSwitch;
